/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
// import "./imageview.css"; // CSS moved to styled-components/injected styles
const Deposits = () => {
  const [user, setUser] = useState()
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState('');
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  // Refs so the 5s auto-refresh interval (set up once) always re-fetches whatever
  // page/limit/search the admin is currently viewing, not the values from mount time.
  const pageRef = useRef(0);
  const limitRef = useRef(10);
  const searchRef = useRef('');

  const profle = (page = pageRef.current, lim = limitRef.current, q = searchRef.current) => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    let url = baseUrl + `temp/deposit/pending?page=${page}&_limit=${lim}`;
    if (q) url += `&_q=${encodeURIComponent(q)}&_stype=Name`;
    axios.get(url, { headers })
      .then((res) => {
        setUser(res.data.data || []);
        setTotalPages(res.data.totalPages || 0);
        setPageNumber(page);
        setLimit(lim);
        setSearch(q);
        pageRef.current = page;
        limitRef.current = lim;
        searchRef.current = q;

        // Wait for DOM to update then attach image viewer
        setTimeout(() => {
          imageViewer();
        }, 200);
      })
  }
  const update = async (id) => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.patch(baseUrl + `temp/deposite/${id}`,
      {
        status: "PAID"
      },
      { headers })
      .then((res) => {
        profle()
      }).catch((e) => {
        console.log(e);
      })
  }
  const cancelledData = async (id) => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.delete(baseUrl + `temp/deposit/delete/${id}`,
      { headers })
      .then((res) => {
        profle()
      }).catch((e) => {
        console.log(e);
      })
  }
  function imageViewer() {
    let imgs = document.getElementsByClassName("img"),
      out = document.getElementsByClassName("img-out")[0];

    if (!out) return;
    for (let i = 0; i < imgs.length; i++) {
        // Prevent adding multiple listeners
      if (!imgs[i].classList.contains("el")) {
        imgs[i].classList.add("el");

        // Removed the toggle listener to avoid conflict, keeping just the open logic which is cleaner
        imgs[i].addEventListener("click", openImage);

        function openImage() {
          let imgElement = document.createElement("img"),
            imgWrapper = document.createElement("div"),
            imgClose = document.createElement("div"),
            container = imgs[i].parentElement; // safer selection
          if(container) container.classList.add("img-panel__selct");

          imgElement.setAttribute("class", "image__selected");
          imgElement.src = imgs[i].src;
          imgWrapper.setAttribute("class", "img-wrapper");
          imgClose.setAttribute("class", "img-close");
          imgWrapper.appendChild(imgElement);
          imgWrapper.appendChild(imgClose);
          setTimeout(
            function () {
              imgWrapper.classList.add("img-wrapper__initial");
              imgElement.classList.add("img-selected-initial");
            }, 50);
          out.appendChild(imgWrapper);
          imgClose.addEventListener("click", function () {
            if(container) container.classList.remove("img-panel__selct");
            out.removeChild(imgWrapper);
          });
        }
      }
    }
  }
  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' });
    return newDate;
  }

  useEffect(() => {
    profle(0, limit, '');
    // Auto-refresh every 5 seconds for real-time updates (reads current page/limit/search via refs)
    const interval = setInterval(() => {
      profle();
    }, 5000);
    return () => clearInterval(interval);
  }, [])
  if (user === undefined) {
    return null
  }
  // Styles
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

    .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }

    .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
    .card-header-custom { background: linear-gradient(45deg, #57155a, #8e44ad); padding: 20px; }
    .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
    /* Toolbar */
    .toolbar { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; padding: 15px 20px 0 20px; }
    .toolbar input, .toolbar select { padding: 8px 12px; border-radius: 8px; border: 1px solid #ddd; }
    .toolbar input { flex: 1 1 220px; }
    /* Table */
    .table-responsive { overflow-x: auto; padding: 0 20px 20px 20px; }
    table.dataTable, .plain-table { width: 100% !important; border-collapse: collapse !important; }
    table.dataTable thead th, .plain-table thead th { background: #f8f9fa !important; color: #636e72 !important; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; padding: 15px 20px; border-bottom: 2px solid #eee; }
    table.dataTable tbody td, .plain-table tbody td { padding: 15px 20px; border-bottom: 1px solid #f1f1f1; vertical-align: middle; color: #2d3436 !important; font-size: 0.9rem; }

    /* Buttons */
    .btn-action { border: none; padding: 6px 14px; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: 0.2s; margin-right: 5px; }
    .btn-approve { background: #27ae60; color: white; }
    .btn-approve:hover { background: #219150; transform: translateY(-2px); }
    .btn-delete { background: #c62828; color: white; }
    .btn-delete:hover { background: #b71c1c; transform: translateY(-2px); }
    .btn-success-static { background: #2ecc71; color: white; cursor: default; }
    /* Image Viewer CSS (embedded) */
    .img-out { position: fixed; top:0; left:0; z-index: 99999; }
    .img-wrapper { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.9); z-index: 99999; display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.3s ease; }
    .img-wrapper__initial { opacity: 1; }
    .image__selected { max-width: 90%; max-height: 90%; border-radius: 10px; transform: scale(0.9); transition: transform 0.3s ease; box-shadow: 0 0 20px rgba(0,0,0,0.5); }
    .img-selected-initial { transform: scale(1); }
    .img-close { position: absolute; top: 30px; right: 30px; width: 40px; height: 40px; background: rgba(255, 255, 255, 0.2); border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: 0.2s; }
    .img-close:hover { background: rgba(255, 255, 255, 0.4); }
    .img-close::before, .img-close::after { content: ''; position: absolute; width: 20px; height: 2px; background: white; transform: rotate(45deg); }
    .img-close::after { transform: rotate(-45deg); }

    .img-panel {  display: inline-block; transition: 0.2s; }
    .img { transition: 0.2s; cursor: pointer; border: 1px solid #ddd; padding: 2px; }
    .img:hover { transform: scale(1.05); border-color: #57155a; }
    .pagination-wrapper { display: flex; justify-content: center; padding: 20px; }
    .pagination-wrapper ul { list-style: none; display: flex; gap: 5px; padding: 0; margin: 0; flex-wrap: wrap; }
    .pagination-wrapper li a { display: block; padding: 6px 12px; border-radius: 6px; border: 1px solid #eee; color: #57155a; cursor: pointer; font-size: 0.85rem; }
    .pagination-wrapper li.active a { background: #57155a; color: #fff; border-color: #57155a; }
  `;
  return (
    <div className="admin-mgmt-page">
      <style>{styles}</style>

      <div className="img-out"></div>

      <div className="row">
        <div className="col-12">
          <div className="modern-card">

            <div className="card-header-custom">
                <h4 className="card-title-custom">Deposit Requests</h4>
            </div>
            <div className="toolbar">
              <input
                type="text"
                placeholder="Search by player name..."
                defaultValue={search}
                onKeyDown={(e) => { if (e.key === 'Enter') profle(0, limit, e.target.value); }}
              />
              <select value={limit} onChange={(e) => profle(0, e.target.value, search)}>
                <option value="10">Show 10</option>
                <option value="20">Show 20</option>
                <option value="50">Show 50</option>
                <option value="100">Show 100</option>
              </select>
            </div>
            <div className="table-responsive" style={{marginTop:'20px'}}>
              <table className="table plain-table" id="depositsPendingTable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Username</th>
                    <th>Amount</th>
                    <th>Txn ID</th>
                    <th>Date</th>
                    <th>Proof</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {user && user.map((item, index) => (
                    <tr key={item._id}>
                      <td style={{color:'#999', fontWeight:'bold'}}>{(pageNumber > 0 ? (pageNumber - 1) * limit : 0) + index + 1}</td>
                      <td><span style={{fontFamily:'monospace', color:'#666'}}>{item._id}</span></td>
                      <td style={{fontWeight:'600'}}>{item.user?.Name}</td>
                      <td style={{fontWeight:'700', color:'#27ae60'}}>₹{item.amount}</td>
                      <td>{item.referenceId || '-'}</td>
                      <td style={{fontSize:'0.85rem', color:'#666'}}>{dateFormat(item.createdAt)}</td>
                      <td>
                        {item.front && (
                          <div className="img-panel">
                            <img
                              className="img"
                              src={baseUrl + `${item.front.replace(/^\/+/, '')}`}
                              style={{ borderRadius: '6px', width: '3.5rem', height: '3.5rem', objectFit: 'cover' }}
                              id={`ss${index}`}
                              alt="Screenshot"
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        {item.status === "Pending" && (
                            <div style={{display:'flex'}}>
                                <button className="btn-action btn-approve" onClick={() => update(item._id)} >Approve</button>
                                <button className="btn-action btn-delete" onClick={() => cancelledData(item._id)} >Reject</button>
                            </div>
                        )}
                        {item.status === "PAID" && <button className="btn-action btn-success-static" >Paid</button>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <div className="pagination-wrapper">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  pageCount={totalPages}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(data) => profle(data.selected + 1, limit, search)}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  activeClassName={"active"}
                  forcePage={pageNumber > 0 ? pageNumber - 1 : 0}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Deposits;
